import { createSimpleFunctional } from '@/util'

export const VBannerActions = createSimpleFunctional('v-banner-actions')
